export default {
	messageTemplates: {
		'err:recoverable': 'Oops! Something went wrong. Please try again in a moment',
		'err:offline': 'Oops! Something went wrong. You may have lost internet connectivity. Please try again in a moment',
		'err:iam_request_timeout': 'Oops! Something went wrong. Please try again in a moment',
		'err:facebook_connect': 'Sorry, there was a problem logging in to Facebook. Please try again',
		'err:fb_user_denied_email': 'Sorry, we have been unable to retrieve your Facebook credentials. Please log in using your email address',
		'err:insufficient_facebook_data': 'Sorry, we have been unable to log in using your Facebook credentials. Please log in using your email address',
		'err:iam_jg_login': 'We\'re having trouble logging you in. Please try again',
		'err:iam_register_email_in_use': 'It looks like you already have an account on JustGiving. Please ',
		'err:iam_email_check': 'We\'re having trouble looking up your email address. Please try again.',
		'err:iam_register': 'We\'re having trouble creating your account. Please try again.',
		'err:emailRequired': 'Please enter your email address',
		'err:emailValid': 'Sorry, the email address you entered is not valid',
		'err:emailMaxLength': 'Sorry, the email address you entered is too long',
		'err:firstNameRequired': 'Please enter your first name',
		'err:firstNameMaxLength': 'Sorry, the first name you entered is too long',
		'err:lastNameRequired': 'Please enter your last name',
		'err:lastNameMaxLength': 'Sorry, the last name you entered is too long',
		'err:passwordRequired': 'Please enter your password',
		'err:passwordMinLength': 'Please enter a password that is at least six characters long',
	},
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/i18n/lang/en/en_errormessages.js